import classNames from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

import Info from '@swf/core/assets/icons/info.svg';
import useScreenSize from '@swf/core/hooks/useScreenSize';

import styles from './StarsInlineTooltip.scss';

interface Props {
  className?: string;
  infoText: React.ReactNode;
}

const StarsInlineTooltip: React.FC<Props> = ({ infoText, className, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [arrowLeftPosition, setArrowLeftPosition] = useState(0);
  const infoRef = useRef<HTMLSpanElement>(null);
  const { windowSize } = useScreenSize();

  useEffect(() => {
    if (infoRef.current && infoRef.current.offsetLeft !== arrowLeftPosition) {
      setArrowLeftPosition(infoRef.current.offsetLeft);
    }
  }, [arrowLeftPosition, windowSize]);

  return (
    <div className={styles.wrapper}>
      <div className={className}>
        {infoText}
        <span ref={infoRef}>
          <Info
            className={classNames(styles.tooltipIcon, {
              [styles.active]: showTooltip
            })}
            onClick={() => setShowTooltip((currentValue) => !currentValue)}
          />
        </span>
      </div>
      {showTooltip && (
        <div className={styles.tooltipContent}>
          <span className={styles.arrow} style={{ left: arrowLeftPosition }} />
          {children}
        </div>
      )}
    </div>
  );
};

export default StarsInlineTooltip;
